import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DEX_DYN_WIDGET_TYPE_ID} from './dex-dyn-widget-type-id';
import {DexDynWidgetComponent} from './dex-dyn-widget.component';
import {DexDynWidgetImplementation} from './dex-dyn-widget.implementation';
import {DexDynWidgetSettingsComponent} from './settings/dex-dyn-widget-settings.component';
import {DexDynWidgetSettingsService} from './settings/dex-dyn-widget-settings.service';

export const DEX_DYN_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:              DEX_DYN_WIDGET_TYPE_ID,
    widgetLabel:               '[DEV] Test',
    widgetImplementationType:  DexDynWidgetImplementation,
    widgetComponentType:       DexDynWidgetComponent,
    widgetSettingsServiceType: DexDynWidgetSettingsService,
    settingsSchema:            [
        {
            name: 'title',
            isShareable: false
        }
    ],
    hasGroupingSupport:          false,
    widgetSettingsComponentType: DexDynWidgetSettingsComponent
};
